"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayNode = void 0;
const tree_node_1 = require("./base/tree.node");
const internal_node_1 = require("./base/internal.node");
class ArrayNode extends internal_node_1.InternalNode {
    _children;
    constructor(children, parent) {
        super({ getText: () => '' }, parent);
        this.parent = parent;
        this._children = children;
        for (const child of children) {
            child.parent = this;
        }
    }
    accept(v) {
        if (v.visitArray)
            v.visitArray(this);
        this.visitChildren(v);
    }
    getReturnType() {
        return '';
    }
    toString() {
        if (!this.hasChildren())
            return '';
        return `[${this._children.map(child => child.toString()).join(', ')}]`;
    }
    get treeNodeType() {
        return tree_node_1.TreeNodeType.ARRAY_NODE;
    }
}
exports.ArrayNode = ArrayNode;
